import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
/**
 * Error message component with 0 context requirement.
 */
const InitErrorMessage = ({ message, error }) => {
    const mainMessage = useMemo(() => {
        if (message) {
            return message;
        }
        else if (error &&
            error.message &&
            import.meta.env.ENVIRONMENT !== 'prod') {
            return error.message;
        }
        return 'Something went wrong!';
    }, [message, error]);
    const secondaryMessage = useMemo(() => {
        if (message && error?.message && import.meta.env.ENVIRONMENT !== 'prod') {
            return error.message;
        }
        return '';
    }, [message, error]);
    const makeRulesImportant = (style) => {
        // Solution for css reset component having more specificity over the styles.
        return style.replace(/(:[^:]+);/g, '$1 !important;');
    };
    const showReloadButton = useMemo(() => error?.message.toLowerCase().includes('dynamically imported module'), [error]);
    const handleReload = useCallback(() => window.location.reload(), []);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: makeRulesImportant(`
          // Inline styles are used since we might not have the css loaded.

          .__x15__error_root {
            margin: auto;
            width: 60%;
            max-width: 700px;
            min-width: 200px;
          }
          .__x15__error_header {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          .__x15__error_iconContainer {
            position: relative;
            padding: 15px;
          }
          .__x15__error_icon {
            display: block;
            position: relative;
            width: 40px;
            height: 40px;
            border: 2px solid #f44336;
            border-radius: 9999px;
          }
          .__x15__error_icon:before, .__x15__error_icon:after {
            content: ' ';
            display: block;
            width: 4px;
            height: 60%;
            position: absolute;
            left: 50%;
            top: 50%;
            background: #f44336;
            border-radius: 2px;
          }
          .__x15__error_icon:before {
            transform: translate(-50%, -50%) rotate(45deg);
          }
          .__x15__error_icon:after {
            transform: translate(-50%, -50%) rotate(-45deg);
          }
          .__x15__error_message {
            font-family: Helvetica;
            font-size: 18px;
            padding: 15px;
            padding-top: 0;
            text-align: center;
            width: 100%;
          }
          .__x15__error_secondaryMessage {
            font-family: Helvetica;
            font-size: 18px;
            margin-top: 4px;
            opacity: 0.7;
            transform: scale(0.9);
          }
          .__x15__error_reloadButton {
            margin: 40px auto;
            box-shadow: none;
            border: 1px solid black;
            border-radius: 5px;
            padding: 8px 24px;
            color: black;
            background: white;
            transition-duration: .2s;
          }
          .__x15__error_reloadButton:hover {
            cursor: pointer;
            background: lightgray;
          }
        `) }, void 0), _jsx("div", { className: "__x15__error_root", children: _jsxs("div", { className: "__x15__error_header", children: [_jsx("div", { className: "__x15__error_iconContainer", children: _jsx("div", { className: "__x15__error_icon" }, void 0) }, void 0), _jsxs("div", { className: "__x15__error_message", children: [_jsx("div", { "data-test": "error:message", children: mainMessage }, void 0), _jsx("div", { className: "__x15__error_secondaryMessage", "data-test": "error:secondary-message", children: secondaryMessage }, void 0), showReloadButton && (_jsx("button", { className: "__x15__error_reloadButton", onClick: handleReload, children: "RELOAD" }, void 0))] }, void 0)] }, void 0) }, void 0)] }, void 0));
};
export default InitErrorMessage;
//# sourceMappingURL=InitErrorMessage.js.map